angular.module('impactx.autoComplete').component('ixUserAvatarAutocomplete', {
        bindings: {
            selected: '=',
            label: '@',
            uri: '@',
            readOnly: '<',
            dialogData: "=",
            onChangeFunc: "&?"
        },
        controller: 'UserAvatarAutocompleteCtrl',
        templateUrl: 'shared/autocomplete/templates/user-avatar-autocomplete.tmpl.html'
    }
);